import React, { useState, useEffect,useContext } from 'react';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import FlowItem from '../components/controls/flowitem';
import JisCheckbox from '../components/controls/jisCheckbox';
import JisButton from '../components/controls/jisButton';
import { ShareContext } from '../context/ShareContext';
import BackLoader from '../components/backloader';
import * as Constants from '../constants';
import '../styles/document_upload.css';
import '../styles/template.css'
import DynamicIcon from '../components/dynamicicon';
import JisDialog from '../components/dialog';
import JisDialogForm from '../components/formdialog';
import PdfViewer from '../components/controls/pdfviewer';
function DocumentUpload() {

    const [cinfo, setCase]=useState({});
    const [flow, setFlow] = useState({pos:1, code:"doc_type"});
    const [flowerror, setFlowError]=useState('');
    const [option, setOption]=useState('');
 const [uploadtype, setUploadType]=useState(option);
 const [activeIndex, setActiveIndex] = useState(-1);
 const [uploadcode, setUploadCode]= useState(0);


      const navigate = useNavigate()
    const {casefeeid} = useParams();
    const { activePage, token, profile,setIsExpired } = useContext(ShareContext)

    
    const [eswear, setEswear] = useState(true);


    const [openDialog, setOpenDialog] = useState(false);
    const [loading,setLoading]= useState(false);



    //for upload document**************************************
   


    const [document, setDocuments] =useState({uplines:[], casedetail:{}});
    const url=`${Constants.apiUrl}/filing/uncompletedUpload/${casefeeid}`;
    const tempUrl= `${Constants.apiUrl}/filing/templates/document`;
    
    
    const [selectedItems, setSelectedItems] = useState({});

    const [openTemp, setOpenTemp ] =useState(false);

    const [templates, setTemplates]=useState([]);
    const [activeRow, setActiveRow] = useState({});
    const [isPreview, setIsPreview] =useState(false);
    const [previewPath, setPreviewPath] = useState(false);
    const [prevImgs, setPrevImgs] =useState([]);
    const [alert, setAlert]=useState ({open:false,title:'', subtitle:''})
    const [caseDetails, setCaseDetails] =useState({});
    const [openType, setOpenType] = useState(false);
    const [isAttendedTo,setisAttendedTo ]=useState(false);



    useEffect(() => {
        LoadDocs();
   LoadTemplates();
       
      }, [])

      useEffect(() => {
        if(uploadtype=='template'){
            LoadTemplates();
        }
      }, [uploadtype])

      const onOk=()=>{
        setAlert({...alert,open:false});
     }

     const onPreview=(obj)=>{
        setIsPreview(true);
        setPreviewPath(obj.path);
     }

    const handleUploadChange =async (e, rowIndex) => {
        var uline= {...document[rowIndex]};
        var updatedselectedItems={...selectedItems};
       // var updateditems=new Set(items);
       var _uplines=document.uplines;
       setActiveIndex(rowIndex);

        const files = e.target.files;
        console.log(files[0]);
        var b64=await Constants.toBase64(files[0]);
        var path =URL.createObjectURL(files[0]);
        var fname=Constants.ReduceFilename(files[0]?.name);

       var a={... _uplines[rowIndex], path, base64:b64.split(',')[1],filename: fname, base64Ext:b64.split(',')[0]};

       _uplines[rowIndex]=a;
   
         setDocuments({...document,uplines:_uplines});

        console.log(_uplines);
      
    };

    const LoadDocs=()=>{
        setLoading(true);
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
          })
            .then((resp) => resp.json())
            .then((data) => {
                setLoading(false);
                console.log(data);
                if(data.code==0){
                    setDocuments({...data.doc,uplines:data.lines});
                   // setUploadType(data.doc1.doctumentType)
                    //setCaseDetails(data.casedetail);
                } else if(data.code==-10){
                      setIsExpired(true);
                  }
                
            })
            .catch(error => {
                console.error(error);
                setLoading(false);
            })
    }

    const LoadTemplates=()=>{
       // setIsLoading(true);
        fetch(tempUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
          })
            .then((resp) => resp.json())
            .then((data) => {
              //  setIsLoading(false);
                if(data.code==0){
                    setTemplates(data.templates);
                } else if(data.code==-10){
                      setIsExpired(true);
                  }
                
            })
            .catch(error => {
                console.error(error);
                //setIsLoading(false);
            })
    }
    // console.log(uploadedFiles);


    const onUploadFiles2= async()=>{
        const uploadurl=`${Constants.apiUrl}/filing/uploadDocument/${casefeeid}`
   
const _uplines = document.uplines.filter(k=>(k.uplineType!=null && k.uploadDate==null)).map(item => ({
                id: item.id,
                uplineType: item.uplineType,
                base64: item.base64,
                base64Ext: item.base64Ext,
                templateId:item.templateid,
                templatetitle: item.templatetitle,
                filename:item.filename
                }));

    const unset= _uplines
      .filter(k=> (k.uplineType=='template' && k.templateId==null) || (k.uplineType!='template' && k.base64==null));
  console.log('the file not set at all')              
  console.log(unset) ;
  if(unset.length>0){
    // a message should pop up
    setFlowError("Please select the associated file or template");
      return;      
  }

  if(_uplines.length==0){
      setFlowError("Please set the file upload type and upload the corresponding documents");
      return; 
  }

  setFlowError('');
  
//loop throu, any type of template must have template id
//and others must have base6
         

            // Sending the FormData using fetch
            setLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(_uplines),
            headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if(data.code==0){
                    //saved already
                    setOpenDialog(true);
                    setUploadCode(data.psastatus);
                    setisAttendedTo(data.isAttendedTo)
                } else if(data.code==-10){
                      setIsExpired(true);
                  }
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
        });
    }

  /*   const onPreview= async(id,uline)=>{
        const uploadurl=`${Constants.apiUrl}/gazette/uploadDocument/preview/${id}`
        
      
        var updatedselectedItems={...selectedItems};
       // var updateditems=new Set(items);
            // Sending the FormData using fetch
            setIsLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(uline),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false);
                console.log('preview details');
                console.log(data);
                if(data.code==0){
                    //saved already
                    var updated={...uline,prev:data}
                    updatedselectedItems[id] = updated;
                    setSelectedItems(updatedselectedItems);
                    
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setIsLoading(false);
        });
    } */

  const onDeleteItem =(id) =>{
    var updatedselectedItems={...selectedItems};
    delete updatedselectedItems[id]
    setSelectedItems(updatedselectedItems);
  }

  const onOpenTemp=(item, ind)=>{
    setOpenTemp(true);
    setActiveRow(item);
    setActiveIndex(ind);
  }
  const onCloseTemp=()=>{
    setOpenTemp(false);
    
  }

  const onOpenType=(item, ind) =>{ //to reset any setting
    setOpenType(true);
    setActiveRow(item);
    setActiveIndex(ind);
  }
  /*  useEffect(() => {
       if(!(activeIndex=-1)){
        //reset the active data set
        var _active={...activeRow};
        
       }
       
      }, [option]) */

  const onCloseType=(item) =>{
    setOpenType(false);
   
  }

  const onSelectTemplate=(selected)=>{
  

    var _uplines=document.uplines;
   var a={..._uplines[activeIndex],templateid:selected.id ,templatetitle:selected.title }
   
   _uplines[activeIndex]=a;
   setDocuments({...document,uplines:_uplines});

   onCloseTemp();
  }

  const onChangeType=()=>{
    //set the option value and use it to update the list, 
   
        var _uplines=document.uplines;
        var single={..._uplines[activeIndex],uplineType:option,base64:null,filename:null,templateid:null};
        _uplines[activeIndex]=single;
        setDocuments({...document,uplines:_uplines});
        setOpenType(false);
    }

    const onSave=()=>{
        // for saving....
    }

    const AddWritAdditionalDoc=()=>{
        // for saving....
        //adding additional line for Writ of Fifa
        const uplinenew={id:0,docuploadId:document.id,
          documentTitle:'Addional Document',gazetteItemId:0
        }
         var _uplines=[...document.uplines,uplinenew];
        setDocuments({...document,uplines:_uplines});
       
    }

  return (
    <div>
      <h4>Document upload</h4>
      <div style={{textAlign:'center'}}><h4>{cinfo?.caseTitle?.toUpperCase()}</h4>
        <h4>{cinfo?.referenceNumber}</h4>
        </div>
       <div  className='multiform'>
        
        
            <div className='view'>
                
                  <div  className='table'>
                    <div class="section-cases">
                    <span>Documents upload from Gazette Selection</span>
                    </div>
                <div>
                    <table class="case-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Document Title</th>
                                <th>Document selected</th>
                                <th>Status</th>
                                <th>Document Type</th>
                                <th></th>
                               
                            </tr>
                        </thead>
                        <tbody>
                            {
                                document?.uplines.map((item, index) => { return (
                                <tr key={index}>
                                    <td>{casefeeid}/{item.docUploadId}/{item.id}</td>
                                    <td>{item.documentTitle}</td>
                                    <td>{item.selectedTemplate}</td>
                                    
                                    <td className={item.uploadDate!=null ? "status uploaded" :"status"}>
                                      {item.uploadDate!=null && ' Uploaded'}
                                     {/*  {item.filename!=null && 'File Selected'} */}

                                    </td>

                                   
                                   {/* <td>{(item.uplineType==null) ?<JisButton onClick={()=>onOpenType(item,index)}>Set Type {item.uplineType}</JisButton> :<span>{item.uplineType}</span>}</td> */}
                                {item.uploadDate==null && <td><JisButton onClick={()=>onOpenType(item,index)}> {item.uplineType==null?'Set Type':item.uplineType}</JisButton></td>}
                                  {item.uploadDate!=null && <td></td> }


                                  
                      {item.uploadDate==null && <td className="file">
 
  {item.uplineType == null ? null : (

    // uplineType is 'template'
    item.uplineType === 'template' ? (
      
        <div className="btn-upload">
          <JisButton
            className="black"
            onClick={() => onOpenTemp(item,index)}
            title={item?.templatetitle}
          >
            {item?.templatetitle == null
              ? 'Select Template'
              : Constants.ReduceString(
                  item.templatetitle,
                  30
                )}
          </JisButton>
          
        </div>
      
    ) : (
      // uplineType is 'attest' or 'not-attest'
      (item.uplineType === 'attest' || item.uplineType === 'not-attest') &&
      
        <div className="btn-upload">
          <input
            type="file"
            accept="application/pdf"
            id={`file-upload-${index}-${0}`}
            onChange={(e) => handleUploadChange(e, index)}
          />
          <label
            htmlFor={`file-upload-${index}-${0}`}
            title={item?.filename}
          >
            {item.path == null
              ? 'Choose File'
              : Constants.ReduceString(
                  item?.filename,
                  30
                )}
          </label>
          {item.path!=null && <JisButton onClick={()=> onPreview(item)}>Preview</JisButton>}
        </div>
      
    )
  )}
</td>}     
{item.uploadDate!=null && <td></td>}
                                </tr>
                                )})
                            }
                        </tbody>
                    </table>
                </div>
                <div className='error-msg'>{flowerror}</div>
<div className='flowbuttongroup'>
  {document.caseType=="writ-of-fifa" &&  <JisButton onClick={AddWritAdditionalDoc} variant="outline">Add Additional documents</JisButton>}
                        <JisButton onClick={onUploadFiles2}>Submit</JisButton>
                        
                    </div>

              {openDialog && 
              <div className={ "dialog-box open" }>
                    {uploadcode === 0 && 
                    <div className="wrapper">
                       
                        <h3>UPLOAD SUCCESSFUL</h3>
                        <div className="main">
                            <p>The upload was successful; the case will now move to the Process Section Assessor’s queue  </p>
                           <JisButton onClick={() =>  navigate('/my-cases')} className='red'>My Cases</JisButton>
                        </div>
                    </div>}
                    {
                        (uploadcode >0 && isAttendedTo) && 
                        <div className="wrapper">
                        <h3>UPLOAD IS SUCCESSFUL</h3>
                        {(document.caseType==null || document.caseType=="document" ) && <div className="main">
                            <p>Upload is successful! You opted for your document(s) to be commissioned through e-Swearing, kindly Click Ok and 
                                check back within your account to see if the Commissioner for Oath (CFO) has scheduled your document(s) for attestation/commissioning. 
                                Ensure you append your e-Signature, append e-Seal and append Date and timestamp electronically to the documents that doesn’t need commissioning before the CFO, 
                                if needed, if you haven’t done so manually before documents were uploaded,
                                 by clciking on e-Swearing tab and select each document that’s within the category.</p>
                            <div className="btns">
                               <JisButton onClick={() =>  navigate('/e-swearing')} className='red'>e-Swearing</JisButton>
                               <JisButton onClick={() =>  navigate('/my-cases')} className='red'>My Cases</JisButton>
                            </div>  
                        </div>}
                       {document.caseType=="writ-of-fifa" && <div className="main">
                            <p>Please goto eswearing to complete the document for ACR to be able to process it</p>
                            <div className="btns">
                            
                               <JisButton onClick={() =>  navigate('/e-swearing')} className='red'>e-Swearing </JisButton>
                            </div>  
                        </div>} 
                    </div>
                    }
                    {
                        (uploadcode >=0 && !isAttendedTo) && 
                        <div className="wrapper">
                        <h3>UPLOAD IS SUCCESSFUL </h3>

                        {(document.caseType==null || document.caseType=="document" ) && <div className="main">
                            <p>Please note some of the documents you have not uploaded will be waiting on your 
                              'Pending upload' side menu, for you to complete. After which the 
                              system decides if you are going to eSwearing or going to PSA.</p>
                            <div className="btns">
                            
                               <JisButton onClick={() =>  navigate('/my-cases')} className='red'>My Cases</JisButton>
                            </div>  
                        </div>  }
                       {document.caseType=="writ-of-fifa" && <div className="main">
                            <p>Please goto eswearing to complete the document for ACR to be able to process it</p>
                            <div className="btns">
                            
                               <JisButton onClick={() =>  navigate('/e-swearing')} className='red'>e-Swearing </JisButton>
                            </div>  
                        </div>} 
                    </div>
                    }
                    
                    
                </div>
}  
          
            </div>
          
          {openTemp && <JisDialogForm title="CASE DOCUMENT TEMPLATES" onClose={() => onCloseTemp()}>
          <div>
            { templates.map((item, id) => { return (   

                    <div className="template" key={id} onClick={() =>onSelectTemplate(item)} title={item.note}>
                        <h3>{item.title}</h3>
                        <div className="create">
                            <p>Select Template</p>
                        
                            <DynamicIcon iname="circle" />
                        </div>
                        <div className="line"></div>
                    </div>
                   )})}
          </div>
</JisDialogForm>}  
         
{openType && <JisDialogForm title="Document Type" onClose={() => onCloseType()}>
          <div>
            <div className="upload-questions">
                        <p className="note">Please select the appropriate option by selecting the checkbox against the following items before proceeding.</p>
                    <div>
                            <JisCheckbox label='I would be submitting documents that is already attested to or commissioned' 
                                value={option=="attest"} onChange={(e)=>setOption(e?'attest':'')} />

                            <JisCheckbox label='I would be submitting documents that are yet to be attested to or commissioned' 
                                value={option=="not-attest"} onChange={(e)=>setOption(e?'not-attest':'')} />

                            <JisCheckbox label='I would be using available templates from JIS, creating related documents such as a writ of summons/Originating summons, amended writ of summons/originating summons, affidavit in support, written address in support, affidavit of compliance, affidavit of non-participation in a settlement, statement of intent and reason to resort to litigation, verifying affidavit further/better affidavit, etc.?' 
                                value={option=="template"} onChange={(e)=>setOption(e?'template':'')} />   

                    </div>

                        <div className='flowbuttongroup'>
                        <JisButton onClick={onChangeType}>Proceed</JisButton>
                    </div>
                    </div>
          </div>
</JisDialogForm>}


           {isPreview && <div className={  "preview open" } style={{overflow:'scroll'}}>
                <div className="heading">
                  <div>
                    <JisButton icon="close"  onClick={() => setIsPreview(false)}> Close Preview</JisButton>
                     </div>
                  
                </div>
               <PdfViewer   pdfUrl={previewPath} />
               
                
                <div className="date-btns">
                    
                  
                </div>
            </div>}

            </div>

        </div> 
        <BackLoader open={loading} />
    </div>
  );
}

export default DocumentUpload;